import * as React from "react"

export default function SearhFailIcon(props) {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.031 14.617l4.283 4.282-1.415 1.415-4.282-4.283A8.96 8.96 0 019 18c-4.968 0-9-4.032-9-9s4.032-9 9-9 9 4.032 9 9a8.96 8.96 0 01-1.969 5.617zm-2.006-.742A6.977 6.977 0 0016 9c0-3.868-3.133-7-7-7-3.868 0-7 3.132-7 7 0 3.867 3.132 7 7 7a6.977 6.977 0 004.875-1.975l.15-.15z"
        fill={props.fill}
      />
      <path
        d="M5.464 6.879L7.586 9l-2.122 2.121 1.415 1.415L9 10.414l2.121 2.122 1.415-1.415L10.414 9l2.122-2.121-1.415-1.415L9 7.586 6.879 5.464 5.464 6.88z"
        fill={props.fill}
      />
    </svg>
  )
}
